import { animate, AnimationQueryMetadata, group, query, style, transition, trigger } from '@angular/animations';

export function sideSwipe(right?: boolean) {
    return [
        style({ position: `relative` }),
        query(`:enter, :leave`, [style({ position: `absolute`, width: `100%` })], { optional: true }),
        query(
            `:enter .report-container, :enter mat-tab-group`,
            [style({ transform: `translateX(${!right ? '100%' : '-100%'})` })],
            { optional: true }
        ),
        query(`:leave .report-container, :leave mat-tab-group`, [style({ transform: `translateX(0%)` })], {
            optional: true
        }),
        query(
            `:leave .title2, :leave .title-container, :leave button, :leave .filter-container, :leave .clickable-field`,
            style({ opacity: 1 }),
            {
                optional: true
            }
        ),
        query(
            `:enter .title2, :enter .title-container, :enter button, :enter .filter-container, :enter .clickable-field`,
            style({ opacity: 0 }),
            {
                optional: true
            }
        ),
        query(`app-footer`, [style({ opacity: 0 })], { optional: false }),
        group([
            query(
                `:leave .report-container, :leave mat-tab-group`,
                [animate(`500ms ease-out`, style({ transform: `translateX(${!right ? '-105%' : '105%'})` }))],
                {
                    optional: true
                }
            ),
            query(
                `:enter .report-container, :enter mat-tab-group, :enter .clickable-field`,
                [animate(`500ms ease-out`, style({ transform: `translateX(0)` }))],
                {
                    optional: true
                }
            ),
            query(
                `:leave .title2, :leave .title-container, :leave button, :leave .filter-container, :leave .clickable-field`,
                [animate(`250ms ease-out`, style({ opacity: 0 }))],
                { optional: true }
            ),
            query(
                `:enter .title2, :enter .title-container, :enter button, :enter .filter-container`,
                [animate(`275ms 325ms ease-out`, style({ opacity: 1 }))],
                {
                    optional: true
                }
            )
        ])
    ];
}

export function verticalSwipe(top?: boolean) {
    return [
        style({ position: `relative` }),
        query(`:enter, :leave`, [
            style({
                position: `fixed`,
                width: `100%`,
                height: '100%',
                overflow: 'hidden'
            })
        ]),
        query(`:enter`, [style({ transform: `translateY(${!top ? '100%' : '-100%'})` })]),
        query(`:leave`, [style({ transform: `translateY(0%)` })]),
        query(`app-footer`, [style({ opacity: 0 })], { optional: true }),
        group([
            query(`:leave`, [
                animate(`500ms ease-out`, style({ transform: `translateY(${!top ? '-100%' : '100%'})`, opacity: 1 }))
            ]),
            query(`:enter`, [animate(`500ms ease-out`, style({ transform: `translateY(0)` }))]),
            query(`:enter app-footer`, [animate(`500ms ease-in`, style({ opacity: 1 }))], { optional: true })
        ])
    ];
}

export const changeOpacity = [
    query(
        `:enter .title2, :enter .title-container, :enter button, :enter .report-container, :enter .filter-container, :enter app-footer, :enter mat-tab-group`,
        style({ opacity: 0 }),
        { optional: false }
    ),
    group([
        query(
            `:enter .title2, :enter .title-container, :enter button, :enter .report-container, :enter .filter-container, :enter app-footer, :enter mat-tab-group`,
            [animate(`300ms 100ms ease-out`, style({ opacity: 1 }))],
            { optional: false }
        )
    ])
];

export function tileShow(className: string[]): AnimationQueryMetadata[] {
    return [
        query(className.join(', '), style({ opacity: 0 }), { optional: false }),
        query(className.join(', '), animate(500, style({ opacity: 1 })), { optional: true })
    ];
}

export function homeToLinks() {
    const fourInARow = window.innerWidth >= 1520;
    const threeInARow = window.innerWidth < 1520 && window.innerWidth >= 1140;
    const twoInARow = window.innerWidth < 1140 && window.innerWidth >= 900;

    const toTheLeft = fourInARow ? [1, 2] : threeInARow ? [1, 2] : twoInARow ? [1, 3] : [1, 2, 3, 4];
    const toTheRight = fourInARow ? [3, 4] : threeInARow ? [3] : twoInARow ? [2, 4] : [];
    const toTheBottom = fourInARow ? [] : threeInARow ? [4] : twoInARow ? [] : [];

    return [
        style({ position: `relative` }),
        query(`:enter, :leave`, [style({ position: `absolute`, width: `100%` })], { optional: true }),
        query(`:leave app-home-card`, [style({ transform: `translateX(0%)` })], { optional: true }),
        query(':leave .header *', style({ opacity: 1 }), { optional: true }),
        query(`:enter .cards`, [style({ transform: `translateY(100vh)` })], { optional: true }),
        query(`:enter .header, app-footer`, [style({ opacity: 0 })], { optional: true }),
        query(`:enter .header-text *`, [style({ opacity: 0 })], { optional: true }),
        group(
            [
                toTheLeft.length
                    ? query(
                          toTheLeft.map(e => `:leave app-home-card:nth-child(${e})`).join(', '),
                          [animate(`500ms ease-out`, style({ transform: `translateX(calc(-50vw - 350px))` }))],
                          { optional: true }
                      )
                    : null,
                toTheRight.length
                    ? query(
                          toTheRight.map(e => `:leave app-home-card:nth-child(${e})`).join(', '),
                          [animate(`500ms ease-out`, style({ transform: `translateX(calc(50vw + 350px))` }))],
                          { optional: true }
                      )
                    : null,
                toTheBottom.length
                    ? query(
                          toTheBottom.map(e => `:leave app-home-card:nth-child(${e})`).join(', '),
                          [animate(`500ms ease-out`, style({ transform: `translateY(calc(50vw + 350px))` }))],
                          { optional: true }
                      )
                    : null,
                query(':leave .header *', animate(500, style({ opacity: 0 })), { optional: true }),
                query(`:enter .cards`, [animate(`500ms 250ms ease-out`, style({ transform: `translateY(0)` }))], {
                    optional: true
                }),
                query(':enter .header-text *', animate('500ms 100ms', style({ opacity: 1 })), { optional: true })
            ].filter(e => e)
        )
    ].filter(e => e);
}

export function linksToHome() {
    const fourInARow = window.innerWidth >= 1520;
    const threeInARow = window.innerWidth < 1520 && window.innerWidth >= 1140;
    const twoInARow = window.innerWidth < 1140 && window.innerWidth >= 900;

    const toTheLeft = fourInARow ? [1, 2] : threeInARow ? [1, 2] : twoInARow ? [1, 3] : [1, 2, 3, 4];
    const toTheRight = fourInARow ? [3, 4] : threeInARow ? [3] : twoInARow ? [2, 4] : [];
    const toTheBottom = fourInARow ? [] : threeInARow ? [4] : twoInARow ? [] : [];

    return [
        style({ position: `relative` }),
        query(`:enter, :leave`, [style({ position: `absolute`, width: `100%` })], { optional: true }),
        toTheLeft.length
            ? query(
                  toTheLeft.map(e => `:enter app-home-card:nth-child(${e})`).join(', '),
                  [style({ transform: `translateX(calc(-50vw - 350px))` })],
                  {
                      optional: true
                  }
              )
            : null,
        toTheRight.length
            ? query(
                  toTheRight.map(e => `:enter app-home-card:nth-child(${e})`).join(', '),
                  [style({ transform: `translateX(calc(50vw + 350px))` })],
                  {
                      optional: true
                  }
              )
            : null,
        toTheBottom.length
            ? query(
                  toTheBottom.map(e => `:enter app-home-card:nth-child(${e})`).join(', '),
                  [style({ transform: `translateY(calc(50vw + 350px))` })],
                  {
                      optional: true
                  }
              )
            : null,
        query(':enter .header *, app-footer', style({ opacity: 0 }), { optional: true }),
        query(':leave .header-text *', style({ opacity: 1 }), { optional: true }),
        query(`:leave .cards`, [style({ transform: `translateY(0)` })], { optional: true }),
        query(`:enter .header`, [style({ background: 'transparent' })], { optional: true }),
        group(
            [
                query(`:enter app-home-card`, [animate(`500ms 250ms ease-out`, style({ transform: `translate(0)` }))], {
                    optional: true
                }),
                query(':enter .header *', animate(500, style({ opacity: 1 })), { optional: true }),
                query(`:leave .cards`, [animate(`500ms ease-out`, style({ transform: `translateY(100vh)` }))], {
                    optional: true
                }),
                query(':leave .header-text *', animate(200, style({ opacity: 0 })), { optional: true })
            ].filter(e => e)
        )
    ].filter(e => e);
}

export const slideInAnimation = trigger(`routeAnimations`, [
    transition(`void => SummaryReports`, changeOpacity),
    transition(`void => Reports`, changeOpacity),
    transition(`Report => Home`, verticalSwipe(true)),
    transition(`Reports => SummaryReports`, sideSwipe()),
    transition(`SummaryReports => Reports`, sideSwipe(true)),
    transition(`Reports => Report`, verticalSwipe()),
    transition(`Report => Reports`, verticalSwipe(true)),
    transition(`Report => SummaryReports`, verticalSwipe(true)),
    transition(`Home => Report`, verticalSwipe()),
    transition(`Home => Hyperlinks`, homeToLinks()),
    transition(`Home => Glossary`, homeToLinks()),
    transition(`Glossary => Home`, linksToHome()),
    transition(`Hyperlinks => Home`, linksToHome()),
    transition(`* => Home`, tileShow([':enter .tile', ':enter app-home-card'])),
    transition(`* => Hyperlinks`, tileShow([':enter .cards', ':enter h2'])),
    transition(`* => Glossary`, tileShow([':enter .cards', ':enter h2'])),
    transition(`* => Reports`, changeOpacity),
    transition(`* => SummaryReports`, changeOpacity)
]);
